import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';

/**
 * IndustryPageHeading — shared top-of-page heading for the eight industry
 * vertical subpages (Logistics, Insurance, Real Estate, Retail, Healthcare,
 * Finance, Manufacturing, Government & Public Safety).
 *
 * Renders once, above each page's existing hero/first section. Reuses the
 * site's existing hero H1 style verbatim (StandardPageLayout heroTitle:
 * text-4xl sm:text-5xl md:text-6xl font-medium text-black/95) — no new
 * colors, fonts, or styles introduced.
 *
 * A small circular pink play button + "See It Live" label is rendered
 * directly under the heading on every industry page and routes to /demos.
 */
const IndustryPageHeading = ({ name, testId }) => (
  <section className="bg-white pt-16 md:pt-20 pb-6 md:pb-8" data-testid={testId}>
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl sm:text-5xl md:text-6xl font-medium text-black/95"
      >
        {name}
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="mt-5 sm:mt-6 flex justify-center"
      >
        <Link
          to="/demos"
          className="group inline-flex items-center gap-3 text-black/70 hover:text-[#E8A0B8] transition-colors duration-200"
          data-testid={`${testId}-see-it-live`}
        >
          <span className="w-9 h-9 rounded-full bg-[#E8A0B8] flex items-center justify-center transition-transform duration-200 group-hover:scale-110">
            <Play className="w-4 h-4 text-white fill-white ml-0.5" />
          </span>
          <span className="text-base sm:text-lg">See It Live</span>
        </Link>
      </motion.div>
    </div>
  </section>
);

export default IndustryPageHeading;
